import React, { useContext } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import PowerBI from './utils/PowerBI';
import UserManagement from './pages/UserManagement';
import NotFound from './pages/NotFound';
import VerifyOTP from './pages/VerifyEmail';
import PublicRoute from './component/PublicRoute';
import ProtectedRoute from './component/ProtectedRoute';
import UserInfo from './component/UserInfo';
import ModulesInfo from './component/ModulesInfo';
import { AuthContext } from './context/Auth';
import { PiUsersThreeFill } from "react-icons/pi";
import { MdViewModule } from "react-icons/md";
import { FaHome } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";
import Looker from './pages/Looker';

const App = () => {
  const { parentModules, title, childCardModules = { childCards: [] }, setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const hideMinNav = ["/login", "/register", "/verify-email"];
  const isActive = (path) => location.pathname === path;

  // Map child card modules to the required format
  const ans = childCardModules?.childCards?.map((childItem, childIndex) => ({
    ...childItem,
    title: childItem.childCardName,
    key: childIndex,
    group_of: childCardModules?.group_of
  }));

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("email");
    localStorage.removeItem("timeLeft");
    localStorage.removeItem("User_info");
    navigate("/login");
  };

  return (
    <div className='relative'>
      <Routes>
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
        <Route path="/verify-email" element={<PublicRoute><VerifyOTP /></PublicRoute>} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard title="Katyayani Dashboard" cardItem={parentModules} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/parent"
          element={
            <ProtectedRoute>
              <Dashboard title={title || []} cardItem={ans || []} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:title/group_id/:groupId/report/:id/group_of/:group_of"
          element={
            <ProtectedRoute>
              <PowerBI />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:title/report/:id"
          element={
            <ProtectedRoute>
              <PowerBI />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Looker />
            </ProtectedRoute>
          }
        />

        <Route
          path="/department/user-management"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        >
          <Route
            path="user-info"
            element={
              <ProtectedRoute>
                <UserInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="modules-info"
            element={
              <ProtectedRoute>
                <ModulesInfo />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route
          path="*"
          element={
            <ProtectedRoute>
              <NotFound />
            </ProtectedRoute>
          }
        />
      </Routes>

      <div className={`bg-white ${hideMinNav.includes(location.pathname) ? "hidden" : ""} md:hidden z-30 fixed left-0 -bottom-1 w-full`}>
        <nav className="lg:hidden px-5 py-4 flex justify-between p-3">
          <button className={`${isActive("/") ? "text-green-700" : ""} flex flex-col items-center justify-center`} onClick={() => navigate("/")}>
            <FaHome className="text-2xl text-center" />
            <span className="text-xs">Home</span>
          </button>

          <button className={`${isActive("/department/user-management/user-info") ? "text-green-700" : ""} flex flex-col items-center justify-center`} onClick={() => navigate("/department/user-management/user-info")}>
            <PiUsersThreeFill className="text-2xl text-center" />
            <span className="text-xs">Users</span>
          </button>

          <button className={`${isActive("/department/user-management/modules-info") ? "text-green-700" : ""} flex flex-col items-center justify-center`} onClick={() => navigate("/department/user-management/modules-info")}>
            <MdViewModule className="text-2xl text-center" />
            <span className="text-xs">Modules</span>
          </button>

          <button className={`${isActive("/logout") ? "text-green-700" : ""} flex flex-col items-center justify-center`} onClick={logout}>
            <IoMdLogOut className="text-2xl text-center" />
            <span className="text-xs">Logout</span>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default App;